import z from 'zod';
import { sendApplicationFormSchema } from './schema';
import { SelectOption } from 'global';
import { SendOcaLinkMutationResponse } from './api/types';

export type SendApplicationFormValues = z.infer<typeof sendApplicationFormSchema>;

export enum SendApplicationFormTemplates {
  Personal = 'personal',
  Lender = 'lender',
}

export interface SendCreditApplicationRenderProps {
  isDataLoading: boolean;
  isSendOcaLinkLoading: boolean;
  lenderProfilesWithOcaOptions: SelectOption<string>[];
  handleSendOcaLink: (values: SendApplicationFormValues) => Promise<SendOcaLinkMutationResponse>;
}
